import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=45b8018d&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8018d",
  null
  
)

export default component.exports